import React from 'react';
import { func, bool, string } from 'prop-types';
import styled from 'styled-components';
import { length } from 'redux-form-validators';

import { Button, Input } from 'semantic-ui-react';

import CommonForm from '~/views/common/Form';
import FormField from '~/views/common/FormField';
import media from '~/styleUtils/media';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const StyledForm = styled(CommonForm)`
    min-width: 400px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    ${media.phone`
        flex-direction: column;
    `}
`;

const StyledFieldWrapper = styled.div`
    margin-right: 10px;
    display: flex;
`;

const SearchForm = ({
    pristine,
    submitting,
    invalid,
    handleReset,
    placeholder = 'Keyword',
    handleSubmit,
    ...rest
}) => (
    <Container>
        <StyledForm submitting={submitting} handleSubmit={handleSubmit} {...rest}>
            <StyledFieldWrapper>
                <FormField
                    name="terms"
                    control={Input}
                    validate={length({ min: 3 })}
                    placeholder={placeholder}
                    icon="search"
                    iconPosition="left"
                    style={{ minWidth: 300 }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && rest.valid) {
                            e.preventDefault();
                            handleSubmit();
                        }
                    }}

                />
            </StyledFieldWrapper>
            <Button.Group>
                <Button
                    disabled={pristine || submitting || invalid}
                    loading={submitting}
                    type="button"
                    content="Search"
                    primary
                    onClick={handleSubmit}
                />
                <Button
                    onClick={handleReset}
                    disabled={pristine || submitting}
                    content="Clear"
                    type="button"
                />
            </Button.Group>
        </StyledForm>
    </Container>
);


SearchForm.propTypes = {
    submitting: bool.isRequired,
    pristine: bool.isRequired,
    invalid: bool.isRequired,
    placeholder: string,
    handleReset: func.isRequired,
    handleSubmit: func,
};

export default SearchForm;
